import * as types from './mutation-types'
import {SET_CURRENT_TEMPLATE} from "./mutation-types";


export const loadBuilderFiles = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`builder/get/files`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const uploadBuilderFiles = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`builder/upload/files`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteBuilderFiles = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`/builder/delete/files`, {params: data}).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const saveTemplate = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/builder/template/${data.id}/save`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getTemplate = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/builder/template/${id}/load`).then((response) => {
            commit(types.SET_CURRENT_TEMPLATE, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

